import React from 'react';
import { renderToString } from 'react-dom/server';
import { get, keys } from 'lodash-es';

import makeChartConfig from '../../../../../../components/Chart/LineChart';
import { apptopiaWatermark } from '../../../../../../utils/charts/renderers';
import { format } from '../../../../../../utils/date';
import { numberToPercentage, numberToHumanChart } from '../../../../../../utils/formatter';

const tooltipPrecisionConfig = { precision: 1 };

export const timeSpendChartConfig = ({ isColumn, series, isPress }) => {
  const isPercentage = isColumn;
  const firstSeriesKey = keys(series)[0];
  const firstSeries = get(series, [firstSeriesKey], []);

  const xTickPositions = firstSeries?.map((value) => value[0]) || [];

  return makeChartConfig({
    chartOptions: {
      spacing: [10, 6, 4, 8],
      height: 230,
      type: isColumn ? 'column' : 'spline',
      events: {
        render() {
          if (isPress) apptopiaWatermark.render(this);
        },
      },
    },
    yAxisOptions: {
      title: null,
      minPadding: 0.01,
      maxPadding: 0.01,
      startOnTick: true,
      min: isColumn ? 0 : undefined,
      max: isColumn ? 100 : undefined,
      tickAmount: 6,
      labels: {
        reserveSpace: true,
        style: {
          color: '#848EA1',
          fontSize: 12,
        },
        formatter() {
          if (isPercentage) {
            return `${this.value}%`;
          }
          return numberToHumanChart(this.value);
        },
      },
      gridLineWidth: 1,
      gridLineColor: '#EDF0F5',
    },
    xAxisOptions: {
      tickLength: 0,
      lineWidth: 1,
      lineColor: '#EDF0F5',
      maxPadding: isColumn ? 0.02 : 0.05,
      crosshair: {
        color: '#E1E5EB',
        width: 1,
      },
      type: 'datetime',
      tickPositions: xTickPositions.length > 0 ? xTickPositions : null,
      showFirstLabel: true,
    },
    xAxisLabels: {
      formatter() {
        if (this.isFirst || this.isLast) {
          return `<span class="text-nowrap">${format(this.value, 'MMM ‘YY')}</span>`;
        }
        return '';
      },
      style: {
        color: '#848EA1',
        fontSize: 12,
        textOverflow: 'none',
        width: 40,
      },
      useHTML: true,
    },
    tooltipOptions: {
      backgroundColor: 'transparent',
      borderWidth: 0,
      borderRadius: 10,
      padding: 0,
      useHTML: true,
      outside: true,
      formatter() {
        if (!Array.isArray(this.points)) return false;

        const pointOptions = this.points[0].point.options;
        const isPartialElem = pointOptions.isPartial;

        const renderTooltipContent = (rowsContent) =>
          renderToString(
            <div
              style={{
                minWidth: '170px',
                borderRadius: '8px',
                border: '1px solid #E1E5EB',
                padding: '12px 16px',
                backgroundColor: '#fff',
                boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.08)',
              }}
            >
              <table className="table">
                <tr>
                  <td className="text-left text-black text-12 p-l-0 p-b-0 pr-md">
                    {format(this.x, 'MMM`YY')} {isPartialElem && '(Partial Period)'}
                  </td>
                </tr>
                {rowsContent}
              </table>
            </div>
          );

        return renderTooltipContent(
          this.points.map((point) => (
            <tr key={point.series.name}>
              <td className="text-left text-black text-14 p-l-0 p-b-0 pr-md">
                <div className="text-truncate text-black text-14" style={{ maxWidth: '100%' }}>
                  <span
                    className="tooltip-bubble-marker"
                    style={{
                      backgroundColor: point.series.color,
                      borderColor: point.series.color,
                    }}
                  />
                  <span>{point.series.name}</span>
                </div>
              </td>
              <td className="text-right text-black text-14 p-l-0 p-b-0">
                {isColumn
                  ? numberToPercentage(point.y, tooltipPrecisionConfig)
                  : numberToHumanChart(point.y, tooltipPrecisionConfig)}
                {!isColumn ? ' minutes' : ''}
              </td>
            </tr>
          ))
        );
      },
    },
  });
};
